// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"787b42f5","455":"a4ead96b"}[chunkId] + ".chunk.js";
};